import React from "react";
import Logo from "/assets/images/swayamRiskLogoBlue.png";
import style from "./Decleartion.module.css";
import Bg from "/assets/PdfNew/pg2-bg.png";


const DeclarationPage = ({ studentData }) => {
  return (
    <div className={style.declarationBg}>
      {/* Background */}
      <img src={Bg} alt="background" className={style.declarationBg} />

      {/* Logo */}
      <img src={Logo} alt="logo" className={style.logo} />


      {/* Content */}
      <div className={style.content}>
        <p className={style.title}>
          <strong>Dear {studentData?.student_name || "Student"},</strong>
        </p>
        <p >
          Most people spend years figuring out what you are about to discover today.
          In Class {studentData?.grade || ""},
          you are already asking the right questions — and that puts you ahead.
        </p>
        <p   >
          This report translates your personality, aptitude, and natural strengths into something actionable —
          a clear, honest map of where your potential can take you.

          At SwayamRise, we built this platform for one reason —
          so that every young person's next step is chosen with clarity, not guesswork.
          Read this with your family. Let it spark the career conversation.
          And whenever you are ready to go deeper, our counsellors are just a conversation away.
          The best is ahead of you. Go get it.
        </p>
        <br />
        <br />

        <p >
          Warm regards,
          <br />

          <strong>Team SwayamRise</strong>
        </p>
      </div>

    </div>
  );
};

export default DeclarationPage;
